import {
  DocumentText,
  Headphone,
  Layer,
  LogoutCurve,
  Wallet,
} from "iconsax-react";
import React from "react";
import { FaAngleLeft } from "react-icons/fa6";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Navbar = ({ user }) => {
  const navigate = useNavigate();
  const { t } = useTranslation("global");

  const handleLogout = () => {
    localStorage.setItem("user", null);
    navigate("/sign");
  };

  return (
    <span className="p-3 rounded-[12px] flex flex-col items-center justify-center gap-1 h-fit bg-white">
      <Link
        to={"/dashboard"}
        className="flex justify-between gap-2 items-center w-full border-b pb-3"
      >
        <span>
          <h5 className="text-[22px] mb-2 text-black">{user?.name}</h5>
          <h6 className="font-bold text-[16px] text-slate-800">
            {user?.phone}
          </h6>
        </span>
        <span>
          <FaAngleLeft />
        </span>
      </Link>
      <div className="w-full flex flex-col gap-2 pt-2">
        <Link
          to={"/dashboard/wallet"}
          className="flex justify-between items-center w-full hover:bg-slate-200 duration-200 p-2 rounded-md"
        >
          <span className="flex items-center gap-2 text-[#111] text-[16px]">
            <Wallet size={26} color="#111" />
            {t("wallet")}
          </span>
          <span>
            <FaAngleLeft />
          </span>
        </Link>
        <Link
          to={"/dashboard/orders"}
          className="flex justify-between items-center w-full hover:bg-slate-200 duration-200 p-2 rounded-md"
        >
          <span className="flex items-center gap-2 text-[#111] text-[16px]">
            <Layer size={26} color="#111" />
            {t("orders")}
          </span>
          <span>
            <FaAngleLeft />
          </span>
        </Link>
        <Link
          to={"/dashboard/bills"}
          className="flex justify-between items-center w-full hover:bg-slate-200 duration-200 p-2 rounded-md"
        >
          <span className="flex items-center gap-2 text-[#111] text-[16px]">
            <DocumentText size={26} color="#111" />
            {t("bills")}
          </span>
          <span>
            <FaAngleLeft />
          </span>
        </Link>
        <Link className="flex justify-between items-center w-full hover:bg-slate-200 duration-200 p-2 rounded-md">
          <span className="flex items-center gap-2 text-[#111] text-[16px]">
            <Headphone size={26} color="#111" />
            {t("support")}
          </span>
          <span>
            <FaAngleLeft />
          </span>
        </Link>
        <div
          onClick={handleLogout}
          className="flex justify-between items-center w-full hover:bg-slate-200 duration-200 p-2 rounded-md cursor-pointer"
        >
          <span className="flex items-center gap-2 text-[#111] text-[16px]">
            <LogoutCurve className="rotate-180" size={26} color="#111" />
            {t("logout")}
          </span>
          <span>
            <FaAngleLeft />
          </span>
        </div>
      </div>
    </span>
  );
};

export default Navbar;
